import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../Store/Reducers';
import { Avatar as AvatarType } from '../../Types';

const Avatar: React.FC<AvatarType> = ({
    role = 'user',
    avatarImage,
    icon,
    title,
    size = 50,
    position = 'absolute',
}) => {
    const userSettings = useSelector((state: RootState) => state.userSettings);
    const avatarData =
        role === 'user'
            ? {
                  displayText: generateAbbreviation(userSettings.givenName + ' ' + userSettings.familyName),
                  isImageAvailable: Boolean(userSettings.image),
                  backgroundColor: 'bg-profile-backgroundColor',
                  textColor: 'text-profile-TextColor',
                  image: userSettings.image || '',
              }
            : {
                  displayText: generateAbbreviation(title || ''),
                  isImageAvailable: Boolean(avatarImage),
                  backgroundColor: 'bg-profile-assistant-BackgroundColor',
                  textColor: 'text-profile-assistant-TextColor',
                  image: avatarImage || '',
              };

    function generateAbbreviation(name: string) {
        if (!name) return '';
        return name
            .split(' ')
            .map((word) => word[0])
            .join('')
            .substring(0, 2)
            .toUpperCase();
    }

    const fontSize = (size / 50) * 16;

    return (
        <div
            className={`top-0 left-0 rounded-full overflow-hidden ${position} ${
                avatarData.isImageAvailable
                    ? role === 'assistant'
                        ? 'bg-layout-bodyBackground'
                        : ''
                    : `${avatarData.backgroundColor}`
            }`}
            style={{
                minWidth: size + 'px',
                minHeight: size + 'px',
                width: size + 'px',
                height: size + 'px',
                fontSize: `${fontSize}px`,
            }}
        >
            <div
                className="relative w-full h-full flex items-center justify-center "
                style={{
                    minWidth: size + 'px',
                    minHeight: size + 'px',
                    width: size + 'px',
                    height: size + 'px',
                    fontSize: `${fontSize}px`,
                }}
            >
                {avatarData.isImageAvailable ? (
                    <img src={avatarData.image} alt={title || 'Avatar'} className="w-full h-full object-cover" />
                ) : (
                    <span className={`block ${avatarData.textColor}`} style={{ lineHeight: `${size}px` }}>
                        {avatarData.displayText}
                    </span>
                )}
                {icon && <div className="absolute bottom-0 right-0">{icon}</div>}
            </div>
        </div>
    );
};

export default Avatar;
